const ACTIVE_TRANSFER_BID_STATUSES = new Set(['pending']);
const ACTIVE_TRANSFER_BID_DISPLAY_STATUSES = new Set(['pending', 'winning', 'losing']);

export const normalizeTransferBidStatus = (status) => (
  typeof status === 'string' ? status.trim().toLowerCase() : ''
);

export const isActiveTransferBid = (bid) => {
  if (!bid) return false;

  const status = normalizeTransferBidStatus(bid.status);
  if (status) {
    return ACTIVE_TRANSFER_BID_STATUSES.has(status);
  }

  const bidStatus = normalizeTransferBidStatus(bid.bidStatus);
  if (bidStatus) {
    return ACTIVE_TRANSFER_BID_DISPLAY_STATUSES.has(bidStatus);
  }

  return true;
};

export const isActiveTransferBidForPlayer = (bid, wyId) => (
  String(bid?.player?.wyId ?? '') === String(wyId ?? '') && isActiveTransferBid(bid)
);
